import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface UserListFiltersState {
    search: string;
    roleFilter: string;
    statusFilter: string;
    pageIndex: number;
}

const initialState: UserListFiltersState = {
    search: '',
    roleFilter: '',
    statusFilter: '',
    pageIndex: 0,
};

const userListFiltersSlice = createSlice({
    name: 'userListFilters',
    initialState,
    reducers: {
        setSearch(state, action: PayloadAction<string>) {
            state.search = action.payload;
            state.pageIndex = 0;
        },
        setRoleFilter(state, action: PayloadAction<string>) {
            state.roleFilter = action.payload;
            state.pageIndex = 0;
        },
        setStatusFilter(state, action: PayloadAction<string>) {
            state.statusFilter = action.payload;
            state.pageIndex = 0;
        },
        setPageIndex(state, action: PayloadAction<number>) {
            state.pageIndex = action.payload;
        },
        resetUserListFilters() {
            return initialState;
        },
    },
});

export const {
    setSearch,
    setRoleFilter,
    setStatusFilter,
    setPageIndex,
    resetUserListFilters,
} = userListFiltersSlice.actions;

export default userListFiltersSlice.reducer;
